import {PermissionScope} from "../../services/auth/permission-scope.enum";
import {PermissionGrant} from "../../services/auth/permission-grant.enum";
import {DtoUtils} from "../../libs/utils/dto.utils";

export class OrgGroupDto {

  public readonly id!: string;
  public name!: string;
  public enabled!: boolean;
  public readonly system!: boolean;
  public permissions: Map<PermissionScope, PermissionGrant> = new Map<PermissionScope, PermissionGrant>();

  constructor(init?: Partial<OrgGroupDto> | undefined) {
    Object.assign(this, init);
    if (init?.permissions) {
      this.permissions = DtoUtils.initPermissions(init.permissions);
    } else {
      this.permissions = new Map();
    }
  }

  public isEditable(): boolean {
    return !this.system;
  }
}
